import http from './http';

export async function getCaptcha() {
  const { data } = await http.get('/api/auth/captcha');
  return data;
}

export async function ensureCsrf() {
  // Ensure XSRF-TOKEN cookie exists before any POST/PUT/DELETE.
  const { data } = await http.get('/api/auth/csrf');
  return data;
}

export async function login(payload) {
  const { data } = await http.post('/api/auth/login', payload);
  return data;
}

export async function logout() {
  const { data } = await http.post('/api/auth/logout');
  return data;
}

export async function changePassword(payload) {
  const { data } = await http.post('/api/auth/change-password', payload);
  return data;
}
